import * as React from 'react';
import { StateDropdown } from '../Common/StateDropdown';
import { StateNode, UserDetailNode, StateNodeEdge, UserDetailNodeEdge } from '../../../schema';
import { UserDetailDropdown } from '../Common/UserDetailDropdown';

export const StateEmployeeSelection: React.StatelessComponent<Props> = (props) => {
  return (
    <div>
      <StateDropdown
        mode='single'
        value={props.selectedState}
        onChange={(v) => {
          props.onStateChange(v.node);
          props.setSelectedState(v);
        }}
        uniqueIdentifier={(v) => v && v.node.id}
        displayProp={(v) => v && v.node.name || ''}
        label='Select State'
      />
      <UserDetailDropdown
        mode='single'
        value={props.selectedEmployee}
        onChange={(v) => {
          props.onEmployeeChange(v.node);
          props.setSelectedEmployee(v);
        }}
        uniqueIdentifier={(v) => v && v.node.id}
        displayProp={(v) => v && v.node.employee.name || ''}
        label='Select Employee'
        inputProps={{ required: true }}
        userType='CALLER'
      />
    </div>
  );
};

interface Props {
  state: StateNode;
  employee: UserDetailNode;
  onStateChange: (state: StateNode) => void;
  onEmployeeChange: (employee: UserDetailNode) => void;
  selectedState: StateNodeEdge;
  selectedEmployee: UserDetailNodeEdge;
  setSelectedState: (selectedState: StateNodeEdge) => void;
  setSelectedEmployee: (selectedEmployee: UserDetailNodeEdge) => void;
}
